<div class="sam-form-flex-row sam-full-width sam-center">
   <samweb-text-area
      style="flex: auto"
      [icon]="icon"
      [header]="header"
      [value]="value"
      [isFocused]="isFocused"
      [disabled]="isDisabled"
      [highlightIcon]="value !== valueOriginal"
      (valueChangedDebounced)="textChangedDebounced($event)"
      (valueChanged)="textChanged($event)"
   ></samweb-text-area>
   <div style="min-width: 20%">
      <div *ngIf="isValueSet" class="sam-form-flex-row" style="align-items: center">
         <div class="sam-margin-left sam-margin-right sam-opacity-medium sam-base-font-size">·</div>
         <div class="sam-opacity-medium sam-sub-font-size">{{ header }}</div>
      </div>
   </div>
</div>

<div *ngIf="isComparatorActive" class="sam-form-flex-row sam-full-width sam-center">
   <fa-icon [icon]="icon" class="sam-margin-left sam-margin-right sam-opacity-off"></fa-icon>
   <div class="sam-form-flex-row sam-full-width">
      <div class="border-box k-bg-warning sam-full-width">
         <div class="sam-margin-left-medium sam-full-width sam-opacity-light">
            {{ valueUpdated }}
         </div>
      </div>
      <button kendoButton (click)="takeOtherClick()" primary="true" class="sam-margin-left">
         <div class="sam-button-text">
            {{ 'common.apply' | translate }}
         </div>
      </button>
   </div>
   <div class="sam-margin-right" style="min-width: 20%">
      <div class="sam-form-flex-row" style="align-items: center">
         <div class="sam-margin-left sam-margin-right-large sam-opacity-off">·</div>
         <div class="sam-opacity-ligth sam-sub-font-size sam-warning sam-italic">
            {{ 'brick.brick_definitions.directory_browser.edit_contact_details.updated_value' | translate }}
         </div>
      </div>
   </div>
</div>
